import { render, staticRenderFns } from "./PPTOption.vue?vue&type=template&id=9dbd0ab8&scoped=true&"
import script from "./PPTOption.vue?vue&type=script&lang=js&"
export * from "./PPTOption.vue?vue&type=script&lang=js&"
import style0 from "./PPTOption.vue?vue&type=style&index=0&id=9dbd0ab8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbd0ab8",
  null
  
)

export default component.exports